'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".IconExpand-module_iconExpand__IdQXp{height:auto;width:1rem}";
var styles = {"iconExpand":"IconExpand-module_iconExpand__IdQXp"};
styleInject["default"](css_248z, 'a60bf479-e5b5-45a3-b7ae-fd20e51cc83f');

exports["default"] = styles;
